import { render } from "./CalculationIndividualItemsSection.vue?vue&type=template&id=5b512217"
import script from "./CalculationIndividualItemsSection.vue?vue&type=script&lang=js"
export * from "./CalculationIndividualItemsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__